/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateClientAppointmentRequest,
  CreateClientAppointmentResponse,
  ProblemDetails,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateClientAppointmentRequestFromJSON,
    CreateClientAppointmentRequestToJSON,
    CreateClientAppointmentResponseFromJSON,
    CreateClientAppointmentResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateClientAppointmentOperationRequest {
    clientId: string;
    createClientAppointmentRequest: CreateClientAppointmentRequest;
}

/**
 * ClientAppointmentsApi - interface
 * 
 * @export
 * @interface ClientAppointmentsApiInterface
 */
export interface ClientAppointmentsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {CreateClientAppointmentRequest} createClientAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAppointmentsApiInterface
     */
    createClientAppointmentRaw(requestParameters: CreateClientAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAppointmentResponse>>;

    /**
     */
    createClientAppointment(requestParameters: CreateClientAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAppointmentResponse>;

}

/**
 * 
 */
export class ClientAppointmentsApi extends runtime.BaseAPI implements ClientAppointmentsApiInterface {

    /**
     */
    async createClientAppointmentRaw(requestParameters: CreateClientAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAppointmentResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createClientAppointment().'
            );
        }

        if (requestParameters['createClientAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientAppointmentRequest',
                'Required parameter "createClientAppointmentRequest" was null or undefined when calling createClientAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/appointments`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientAppointmentRequestToJSON(requestParameters['createClientAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAppointmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async createClientAppointment(requestParameters: CreateClientAppointmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAppointmentResponse> {
        const response = await this.createClientAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
